import { Container } from 'app/components/ui/Container'
import { Image } from 'app/components/ui/Image'
import { useAuth } from 'app/contexts/AuthenticationProvider'
import { useLogout } from 'app/queries/logout'
import { protectedRoutes } from 'app/routing/routes'
import React from 'react'
import { Link } from 'react-router-dom'
import logo from 'static/images/estra_logo.svg'
import styled from 'styled-components'

import { TopMenuDropdown } from '../TopMenuDropdown'

export const TopMenu = (): JSX.Element => {
  const { user, logout } = useAuth()

  const { mutate: executeLogout } = useLogout(logout)

  const onLogout = () => executeLogout()

  return (
    <Wrapper>
      <NavbarContainer>
        <Navbar>
          <Brand to={protectedRoutes.dashboard.path}>
            <Image src={logo} alt='estra'></Image>
          </Brand>
          {user && <TopMenuDropdown onLogout={onLogout}></TopMenuDropdown>}
        </Navbar>
      </NavbarContainer>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  padding-top: 1rem;
  padding-bottom: 2.5rem;

  background-color: ${({ theme }) => theme.color.neutri.grigioBg};

  @media (min-width: ${({ theme }) => theme.bp.tablet}) {
    padding-top: 2.5rem;
  }
`

const NavbarContainer = styled(Container)``

const Navbar = styled.div`
  display: flex;
  justify-content: space-between;
`

const Brand = styled(Link)`
  display: block;

  img {
    height: 24px;
  }
  @media (min-width: ${({ theme }) => theme.bp.tablet}) {
    img {
      height: 38px;
    }
  }
  @media (min-width: 1000px) {
    img {
      height: 43px;
    }
  }
`
